import { useApis } from '../../../contexts/api-context'
import Toaster from '../../../utilities/toaster'

const useRegisterEmployeeEmail = () => {
  const { api } = useApis()

  return async (email: string, companySlug: string): Promise<boolean> => {
    try {
      const savedRes = await api.verifyEmployeeEmail(companySlug, email)

      if (savedRes.data.type === 'ALREADY_EXISTS') {
        Toaster.success('component.toaster.employeeAlreadyExists')
      } else {
        Toaster.success('component.toaster.employeeSentEmail')
      }

      return true
    } catch (e: any) {
      console.log(e)
      if (e.data.type === 'BAD_REQUEST') {
        Toaster.error('errors.employeeInvalidEmail')
      } else {
        Toaster.error('errors.defaultError')
      }
      return false
    }
  }
}

export default useRegisterEmployeeEmail
